(function() {

    /* ==========================
       COOKIE FUNCTIONS
    ========================== */

    function setCookie(name, value, hours) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (hours * 60 * 60 * 1000));

        document.cookie =
            name + "=" + encodeURIComponent(value) +
            "; expires=" + expires.toUTCString() +
            "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i].trim();

            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }

    /* ==========================
       CAPTURE tw_creator
    ========================== */

    var params = new URLSearchParams(window.location.search);
    var twCreator = params.get("tw_creator");

    if (twCreator) {
        setCookie("tw_creator", twCreator, 1);
    }

    /* ==========================
       PRODUCT PAGE ONLY
    ========================== */

    if (
        window.location.pathname !==
        "/products/deodorizing-soap-with-persimmon"
    ) {
        return;
    }

    var creator = getCookie("tw_creator");

    if (!creator) {
        return;
    }

    /* ==========================
       IMAGE MAPPING
    ========================== */

    var imageMap = {
        jared: "//miraiclinical.com/cdn/shop/files/MIrai_Clinical_Jared_Deo_Soap_Hero_FB.webp",
        koko: "//miraiclinical.com/cdn/shop/files/Mirai_Clinical_Koko_FB.webp",
        blane: "//miraiclinical.com/cdn/shop/files/Dr._Blane_Deodorizing_Persimmon_Soap_Mirai_Clinical.webp",
        maria: "//miraiclinical.com/cdn/shop/files/Dr._Maria_S_Mirai_Clinical_Deodorizing_Soap_with_Persimmon_Doctor_Expert.webp"
    };

    var replacementImage = imageMap[creator];

    if (!replacementImage) {
        return;
    }

    /* ==========================
       BUILD SRCSET
    ========================== */

    function buildSrcset(url) {

        var widths = [
            246,493,600,713,823,990,
            1100,1206,1346,1426,1646,1946
        ];

        return widths.map(function(w) {
            return url + "?width=" + w + " " + w + "w";
        }).join(", ");
    }

    /* ==========================
       REPLACE MAIN IMAGE ONLY
    ========================== */

    function replaceMainImage() {

        var mainImage = document.querySelector(
            '.product__media img'
        );

        if (!mainImage) {
            return;
        }

        mainImage.src =
            replacementImage + "?width=1946";

        mainImage.setAttribute(
            "srcset",
            buildSrcset(replacementImage)
        );

        if (mainImage.dataset.src) {
            mainImage.dataset.src = replacementImage;
        }

        if (mainImage.dataset.zoomImage) {
            mainImage.dataset.zoomImage = replacementImage;
        }
    }

    /* ========================== 
       REPLACE FIRST THUMBNAIL ONLY
    ========================== */

    function replaceFirstThumbnail() {

        var firstThumb = document.querySelector(
            '.thumbnail img'
        );

        if (!firstThumb) {
            return;
        }

        firstThumb.src =
            replacementImage + "?width=300";

        firstThumb.removeAttribute("srcset");
    }

    /* ==========================
       RUN
    ========================== */

    function applyChanges() {
        replaceMainImage();
        replaceFirstThumbnail();
    }

    setTimeout(applyChanges, 1000);

})();
 